import React from "react";
import { Button, Card, CardBody } from "reactstrap";

// Keeps a crash in one page from unmounting the whole app (blank screen).
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.log(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card>
          <CardBody className="text-center">
            <h4>Something went wrong loading this page.</h4>
            <Button color="primary" onClick={() => window.location.reload()}>
              Reload
            </Button>
          </CardBody>
        </Card>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
